import React from "react";
import { useUser } from "../components/UserContext";

function usePermission() {
  const { user } = useUser();
  const hasPermission = (permission?: string) => {
    if (!permission) return true; // ✅ Home always visible

    // Admin bypass
    if (user?.role === "Owner") return true;

    const [module, action] = permission.split("_");

    return (user?.permissions as unknown as Record<string, string[]>)?.[module]?.includes(action);
  };
  return { hasPermission };
}

export default usePermission;
